import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { useTranslations } from 'next-intl';
import { FaCircleCheck, FaUser } from 'react-icons/fa6';
import { LiaMarsSolid, LiaVenusSolid } from 'react-icons/lia';
import { type ListingDataView } from '@/features/listing/types/listing-types';
import { VerificationStatus } from '@/features/user/types/user-id-verification-types';
import { GENDERS_KEYS, type User } from '@/features/user/types/user-types';
import Avatar from '@/ui/avatar/avatar';
import styles from './listing-user.module.scss';
interface ListingUserProps {
  user: User;
  view?: ListingDataView;
  isNotActive?: boolean;
  avatarSize?: number;
}
export default function ListingUser(props) {
  const $ = _c(29);
  const {
    avatarSize: t0,
    isNotActive: t1,
    user,
    view: t2
  } = props;
  const avatarSize = t0 === undefined ? 40 : t0;
  const isNotActive = t1 === undefined ? false : t1;
  const view = t2 === undefined ? "isCard" : t2;
  const {
    age,
    avatar,
    firstName,
    gender,
    verifications
  } = user;
  const translationsVerifications = useTranslations("global.verifications");
  const t3 = view === "isDetailed" && styles.listingUser__isDetailed;
  const t4 = view === "isUserListings" && styles.listingUser__isUserListings;
  const t5 = isNotActive && styles.listingUser__isNotActive;
  let t6;
  if ($[0] !== t3 || $[1] !== t4 || $[2] !== t5) {
    t6 = cx(styles.listingUser, t3, t4, t5);
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const t7 = view === "isUserListings" ? 80 : avatarSize;
  const t8 = view === "isUserListings" ? "square" : "circle";
  let t9;
  if ($[4] !== avatar.pathSmall || $[5] !== firstName || $[6] !== t7 || $[7] !== t8) {
    t9 = <Avatar imageSrc={avatar.pathSmall} alt={firstName} size={t7} view={t8} />;
    $[4] = avatar.pathSmall;
    $[5] = firstName;
    $[6] = t7;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== age || $[10] !== firstName || $[11] !== view) {
    t10 = view === "isCard" && <p className={styles.listingUser__info}>{firstName},  {age}</p>;
    $[9] = age;
    $[10] = firstName;
    $[11] = view;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== age || $[14] !== firstName || $[15] !== gender || $[16] !== translationsVerifications || $[17] !== verifications || $[18] !== view) {
    t11 = view === "isUserListings" && <div><div className={styles.listingUser_details}><p className={styles.listingUser__info}>{firstName},  {age}</p>{gender && <div className={styles.listingUser__gender}>{gender === GENDERS_KEYS.Female && <LiaVenusSolid name="female" strokeWidth={1.3} />}{gender === GENDERS_KEYS.Male && <LiaMarsSolid name="male" strokeWidth={1.3} />}</div>}</div>{verifications.id?.status === VerificationStatus.Passed && <div className={styles.listingUser_verified}><div className={styles.listingUser_status}><FaCircleCheck className={styles.listingUser_checked} /><FaUser className={styles.listingUser_icon} /></div><p className={styles.listingUser_text}>{translationsVerifications("id-checked")}</p></div>}</div>;
    $[13] = age;
    $[14] = firstName;
    $[15] = gender;
    $[16] = translationsVerifications;
    $[17] = verifications;
    $[18] = view;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== gender || $[21] !== view) {
    t12 = view === "isCard" && gender && <div className={styles.listingUser__gender}>{gender === GENDERS_KEYS.Female && <LiaVenusSolid name="female" strokeWidth={1.3} />}{gender === GENDERS_KEYS.Male && <LiaMarsSolid name="male" strokeWidth={1.3} />}</div>;
    $[20] = gender;
    $[21] = view;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t12 || $[26] !== t6 || $[27] !== t9) {
    t13 = <div className={t6}>{t9}{t10}{t11}{t12}</div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
    $[26] = t6;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
}